export const state = {
  filters: {
    vehicleStatus: ['Active', 'Stopped', 'Inactive'],
    vehicleGroups: [],
    selectedPois: [],
    keyword: ''
  }
}

export const mutations = {
  SET_VEHICLE_STATUS(state, vehicleStatuses) {
    state.filters.vehicleStatus = vehicleStatuses
  },
  SET_VEHICLE_GROUPS(state, vehicleGroups) {
    state.filters.vehicleGroups = vehicleGroups
  },
  SET_SELECTED_POIS(state, selectedPois) {
    state.filters.selectedPois = selectedPois
  },
  SET_KEYWORD(state, searchKeyword) {
    state.filters.keyword = searchKeyword
  },
  RESET_FILTERS(state) {
    state.filters.vehicleStatus = [
      'Moving',
      'Turned off',
      'Stopped',
      'Inactive'
    ]
    state.filters.vehicleGroups = []
    state.filters.selectedPois = []
    state.filters.keyword = ''
  }
}

export const actions = {
  setVehicleStatus({ commit }, vehicleStatuses) {
    commit('SET_VEHICLE_STATUS', vehicleStatuses)
  },
  setVehicleGroups({ commit }, vehicleGroups) {
    commit('SET_VEHICLE_GROUPS', vehicleGroups)
  },
  setSelectedPois({ commit }, selectedPois) {
    commit('SET_SELECTED_POIS', selectedPois)
  },
  setKeyword({ commit }, searchKeyword) {
    commit('SET_KEYWORD', searchKeyword)
  },
  resetFilters({ commit }) {
    commit('RESET_FILTERS')
  }
}

export const getters = {
  getFilterFunction: state => {
    const filterByKeyword = vehicles => {
      if (!state.filters.keyword) {
        vehicles.forEach(vehicle => {
          vehicle.appliedFilters.keyword = true
        })
      } else {
        vehicles.forEach(vehicle => {
          if (
            vehicle.driverName && vehicle.driverName
              .toLocaleLowerCase()
              .includes(state.filters.keyword.toLocaleLowerCase()) ||
            vehicle.vehicleLabel
              .toLocaleLowerCase()
              .includes(state.filters.keyword.toLocaleLowerCase()) ||
            vehicle.todayKillometers
              .toString()
              .toLocaleLowerCase()
              .includes(state.filters.keyword.toLocaleLowerCase()) ||
              vehicle.poi && vehicle.poi.name && vehicle.poi.name
              .toLocaleLowerCase()
              .includes(state.filters.keyword.toLocaleLowerCase()) ||
            vehicle.tenantName && vehicle.tenantName
              .toLocaleLowerCase()
              .includes(state.filters.keyword.toLocaleLowerCase())
          ) {
            vehicle.appliedFilters.keyword = true
          } else {
            vehicle.appliedFilters.keyword = false
          }
        })
      }
    }

    const filterByStatus = vehicles => {
      if (state.filters.vehicleStatus.length == 4) {
        vehicles.forEach(vehicle => {
          vehicle.appliedFilters.status = true
        })
      } else {
        vehicles.forEach(vehicle => {
          vehicle.appliedFilters.status = false

          if (
            vehicle.color === 1 &&
            state.filters.vehicleStatus.includes('Moving')
          ) {
            vehicle.appliedFilters.status = true
          }
          if (
            vehicle.color === 3 &&
            state.filters.vehicleStatus.includes('Inactive')
          ) {
            vehicle.appliedFilters.status = true
          }
          if (
            vehicle.color === 2 &&
            state.filters.vehicleStatus.includes('Stopped')
          ) {
            vehicle.appliedFilters.status = true
          }
          if (
            vehicle.color === 4 &&
            state.filters.vehicleStatus.includes('StoppedTurnedOn')
          ) {
            vehicle.appliedFilters.status = true
          }
        })
      }
    }

    const filterByGroup = vehicles => {
      // console.log(state.filters.vehicleGroups)
      if (!state.filters.vehicleGroups.length) {
        vehicles.forEach(vehicle => {
          vehicle.appliedFilters.group = true
        })
      } else {
        let localVehicles = []
        vehicles.forEach(vehicle => {
          state.filters.vehicleGroups.forEach(group => {
            if (vehicle.vehicleGroupIds.includes(group)) {
              if (!localVehicles.some(v => v.imei == vehicle.imei)) {
                localVehicles.push(vehicle)
              }
            }
          })
          vehicles.forEach(vehicle => (vehicle.appliedFilters.group = false))
          localVehicles.forEach(
            vehicle => (vehicle.appliedFilters.group = true)
          )
        })
      }
    }

    const filterByPoi = vehicles => {
      if (!state.filters.selectedPois.length) {
        vehicles.forEach(vehicle => {
          vehicle.appliedFilters.poi = true
        })
      } else {
        vehicles.forEach(vehicle => {
          vehicle.appliedFilters.poi =
            vehicle.poi && state.filters.selectedPois.includes(vehicle.poi.id)
        })
      }
    }

    const changeRouteVisibility = (vehicles, routes) => {
      vehicles.forEach(vehicle => {
        routes.forEach(route => {
          if (vehicle.imei == route.id) {
            route.visible = vehicle.shouldDisplay()
          }
        })
      })
    }

    return [
      filterByKeyword,
      filterByStatus,
      filterByGroup,
      filterByPoi,
      changeRouteVisibility
    ]
  }
}

export const namespaced = true
